import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { createDraft } from 'src/app/pages/homepage/shared/api';
import { generateRecommendedPetitionAnglesJob } from 'src/app/shared/api/recommendedPetitionAngles';

export function useCreateRecommendations() {
	const queryClient = useQueryClient();
	const utilityContext = useUtilityContext();

	return useMutation({
		mutationFn: async (issue: string) => {
			let recommendationsJobId: string | undefined;
			try {
				const { responseId } = await generateRecommendedPetitionAnglesJob({ mainPrompt: issue }, utilityContext);
				recommendationsJobId = responseId;
			} catch {
				// If the job creation fails, we still want to proceed with creating a draft without the job ID.
			}

			const draft = {
				input: { issuePrompt: issue },
				type: 'recommendations_variant_b_draft' as const,
				metadata: { recommendationsJobId },
			};

			return createDraft(draft, { queryClient });
		},
	});
}
